"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataAssociations = exports.metadataAssociation = exports.metadataDefinitions = exports.metadataDefinition = void 0;
exports.metadataDefinition = {
    id: 1,
    beanNotation: "root.patientVisit.encounter.provider.idno",
    metadataSourceId: 1,
    metadataSource: {
        id: 2,
        microserviceServiceName: "Patient Service",
        method: null,
        metadataAssociations: null
    },
    dataType: "identifier",
    metadataDefinitionName: "Provider Id",
    metadataVarName: "providerId",
    metadataGroup: null,
    predicateField: "identifierType",
    predicateValue: "MRN",
    automatedFetch: null
};
var def2 = {
    id: 16,
    beanNotation: null,
    metadataSourceId: null,
    metadataSource: {
        id: 16,
        microserviceServiceName: "Document Service",
        method: null,
        metadataAssociations: null
    },
    dataType: null,
    metadataDefinitionName: "Notes",
    metadataVarName: "notes",
    metadataGroup: null,
    predicateField: null,
    automatedFetch: false,
    predicateValue: null
};
exports.metadataDefinitions = {
    content: [exports.metadataDefinition, def2],
    pageable: {
        sort: {
            sorted: true,
            unsorted: false,
            empty: false
        },
        offset: 0,
        pageSize: 5,
        pageNumber: 0,
        paged: true,
        unpaged: false
    },
    last: false,
    totalPages: 2,
    totalElements: 6,
    size: 5,
    number: 0,
    numberOfElements: 5,
    first: true,
    sort: {
        sorted: true,
        unsorted: false,
        empty: false
    },
    empty: false
};
exports.metadataAssociation = {
    required: true,
    id: 234,
    metadataDefinitionId: exports.metadataDefinition.id,
    associationGroupId: 234,
    metadataDefinition: exports.metadataDefinition
};
exports.metadataAssociations = {
    content: [exports.metadataAssociation],
    pageable: {
        sort: {
            sorted: true,
            unsorted: false,
            empty: false
        },
        offset: 0,
        pageSize: 5,
        pageNumber: 0,
        paged: true,
        unpaged: false
    },
    last: false,
    totalPages: 2,
    totalElements: 6,
    size: 5,
    number: 0,
    numberOfElements: 5,
    first: true,
    sort: {
        sorted: true,
        unsorted: false,
        empty: false
    },
    empty: false
};
//# sourceMappingURL=metadata-definitions.js.map